import React from 'react';

interface Props {
  pageContext: {
    html: string;
  };
}

const RawHtmlPage: React.FC<Props> = ({ pageContext }) => {
  return (
    <div style={{ width: '100vw', height: '100vh', overflow: 'hidden' }}>
      <iframe
        title="PDF Page"
        srcDoc={pageContext.html}
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          display: 'block',
        }}
      />
    </div>
  );
};

export default RawHtmlPage;
